$(window).on('load scroll', function() {
	let footer = $('#footer');
	let elem = $('.js-footer-fixed');
	if (footer.length && elem.length) {
		if (($(window).scrollTop() + $(window).outerHeight()) > footer.offset().top) {
			elem.addClass('hide');
		} else {
			elem.removeClass('hide');
		}
	}
});
